export function formatRelativeTime(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  const deltaSeconds = Math.round((parsed.getTime() - Date.now()) / 1000);
  const formatter = new Intl.RelativeTimeFormat("zh-CN", { numeric: "auto" });
  const ranges: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ["year", 60 * 60 * 24 * 365],
    ["month", 60 * 60 * 24 * 30],
    ["week", 60 * 60 * 24 * 7],
    ["day", 60 * 60 * 24],
    ["hour", 60 * 60],
    ["minute", 60],
  ];

  for (const [unit, seconds] of ranges) {
    if (Math.abs(deltaSeconds) >= seconds) {
      return formatter.format(Math.round(deltaSeconds / seconds), unit);
    }
  }
  return "刚刚";
}

export function absoluteShortUrl(shortUrl: string): string {
  if (/^https?:\/\//.test(shortUrl)) {
    return shortUrl;
  }
  const localHost = /^(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?\//.test(
    shortUrl,
  );
  return `${localHost ? "http" : "https"}://${shortUrl}`;
}
